import { Routes, Route, Navigate } from "react-router-dom";

import {
  Sidebar,
  Registrations,
  AllUsers,
  AllRechargesData,
  Analytics,
  Pricing,
  PartnerProfile,
} from "../components";
import { useAppContext } from "../contexts/AppContextProvider";
import { canViewPartnerRecharges } from "../utils/partnerAccess.js";

const Dashboard = () => {
  const { partnerInfo } = useAppContext();
  const canViewRecharges = canViewPartnerRecharges(partnerInfo);

  return (
    <div className="max-h-screen w-full md:flex">
      <Sidebar />

      <div className="w-full overflow-y-scroll">
        <Routes>
          <Route path="/" element={<Navigate to="all-users" />} />
          <Route path="/all-users" element={<AllUsers />} />
          <Route path="/registrations" element={<Registrations />} />
          <Route
            path="/all-recharges"
            element={
              canViewRecharges ? (
                <AllRechargesData />
              ) : (
                <Navigate replace to="/all-users" />
              )
            }
          />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/profile" element={<PartnerProfile />} />

          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </div>
    </div>
  );
};

export default Dashboard;
